// ** React Imports
import { useEffect } from 'react'
// import { NavLink } from 'react-router-dom'

// ** Icons Imports
import { Disc, X, Circle } from 'react-feather'

// ** Config
// import themeConfig from '@configs/themeConfig'

import logo from './../../../../../assets/images/logo/logo-registro_color.png'
import logoMini from './../../../../../assets/images/logo/logo_ro.png'

import tittle from './../../../../../assets/images/logo/titulo-01.png'
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import { setSwitchNav } from '../../../../../redux/slice/const'
import { useSelector, useDispatch } from 'react-redux'
import { Route, NavLink } from "react-router-dom"
import './style-header.scss'
// import MetaTags from 'react-meta-tags'

const VerticalMenuHeader = props => {
  const { menuCollapsed, setMenuCollapsed, setMenuVisibility, setGroupOpen, menuHover } = props
  const { switchNav } = useSelector(state => state.globalConst)
  const dispatch = useDispatch();

  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([])
  }, [menuHover, menuCollapsed])

  useEffect(() => {
    dispatch(setSwitchNav({ status: false }))
  }, [])

  const goToEvent = () => {
    dispatch(setSwitchNav({ status: true }))
  }

  const Toggler = () => {
    if (!menuCollapsed) {
      return (
        <Disc
          size={20}
          data-tour='toggle-icon'
          className='text-primary toggle-icon d-none d-xl-block'
          onClick={() => setMenuCollapsed(true)}
        />
      )
    } else {
      return (
        <Circle
          size={20}
          data-tour='toggle-icon'
          className='text-primary toggle-icon d-none d-xl-block'
          onClick={() => setMenuCollapsed(false)}
        />
      )
    }
  }

  return (
    <div>
      {/* <MetaTags>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
      </MetaTags> */}
      <div className='navbar-header'>
        <ul className='nav navbar-nav flex-row'>
          <li className='nav-item me-auto'>
            <NavLink to='/' className='navbar-brand'>
              <div className='navbar-brand'>
                <Route render={({ history }) => (
                  <span className='brand-logo' onClick={() => { goToEvent(); }}>
                    {menuCollapsed ?
                      <>
                        <img src={logoMini} alt='logo' width='50' />
                      </>
                      :
                      <>
                        <img src={logo} alt='logo' width='165' />
                      </>
                    }
                  </span>
                )} />
              </div>
            </NavLink>
          </li>
          <li className='nav-item nav-toggle'>
            <div className='nav-link modern-nav-toggle cursor-pointer'>
              <Toggler />
              <X onClick={() => setMenuVisibility(false)} className='toggle-icon icon-x d-block d-xl-none' size={20} />
            </div>
          </li>
        </ul>
      </div>
      <div>
        {!menuCollapsed ?
          <div>
            <br /><br /><br />
            <span className='brand-logo'>
              <div style={{ backgroundImage: `url(${tittle})`, textAlign: "center" }}>
                {/* <h1 >Nombre del evento</h1> */}
              </div>
            </span>
            <br /><br /><br /><br />
            {/* <div style={{ justifyContent: "center", display: "flex" }}>
              <Route render={({ history }) => (
                <button className='start-button ripple' onClick={() => { goToEvent(); history.push('/') }}>
                  <ArrowCircleLeftOutlinedIcon fontSize="large" style={{ marginRight: "25%", marginLeft: "3%" }} />
                  Inicio
                </button>
              )} />
            </div> */}
            <br />
          </div>
          : <></>}
      </div>
    </div>
  )
}

export default VerticalMenuHeader